export type BaseRouteParam = Record<string, unknown>;
export type ArticleRouteParam = BaseRouteParam & { id: string };
export type SectionRouteParam = BaseRouteParam & {
  level1: string;
  level2?: string;
};
export type RouteParam = BaseRouteParam | ArticleRouteParam | SectionRouteParam;

export enum Section {
  POLICTICS = "politics",
  ECONOMY = "economy",
  TECHNOLOGY = "technology",
  HISTORY = "history",
  SOCIETY = "society",
  CULTURE = "culture",
  CARTOON = "cartoon",
}

const realSections = [
  Section.POLICTICS,
  Section.ECONOMY,
  Section.TECHNOLOGY,
  Section.HISTORY,
  Section.SOCIETY,
  Section.CULTURE,
  Section.CARTOON,
];

/**
 * @description check if the section is a real section, including 观点, 新闻, 特写, 视频
 */
export const isRealSection = (
  section: string,
): section is
  | Section.POLICTICS
  | Section.ECONOMY
  | Section.TECHNOLOGY
  | Section.HISTORY
  | Section.SOCIETY
  | Section.CULTURE
  | Section.CARTOON => realSections.includes(section as Section);
